<template>
  <div class="text-center IranSans">
    <v-dialog v-model="dialog" height="600px" max-width="950px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
          @click="initializeUserRole"
        >
          تخصیص نقش‌ها / مجموعه‌ها
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="IranSans indigo white--text text-h5">
          تخصیص نقش‌ها / مجموعه‌ها
        </v-card-title>

        <v-tabs v-model="mode" background-color="grey lighten-4" grow>
          <v-tab><span class="IranSans">بر اساس مجموعه</span></v-tab>
          <v-tab><span class="IranSans">بر اساس نقش</span></v-tab>
        </v-tabs>

        <v-tabs-items v-model="mode" style="height: 370px;">
          <!-- تب اول: فیلتر فعال/غیرفعال اضافه شد -->
          <v-tab-item>
            <div style="height: 370px; overflow: auto;">
              <v-row class="py-2 ma-0" style="height: 100%;">
                <v-col
                  cols="5"
                  class="pa-0 px-4"
                  style="height: 100%; overflow: auto;"
                >
                  <div
                    class="text-subtitle-1 IranSans font-weight-medium mb-2 grey--text text--darken-2"
                  >
                    انتخاب مجموعه
                  </div>

                  <div
                    style="height: calc(100% - 40px); overflow-y: auto; padding-right: 8px;"
                  >
                    <!-- فیلتر فعال/غیرفعال برای درخت مجموعه‌ها -->
                    <v-row no-gutters class="mb-3 px-1">
                      <v-checkbox
                        v-model="complexShowOnlyActive"
                        label="نمایش مجموعه‌های فعال"
                        color="indigo"
                        hide-details
                        class="mt-0 ml-2 mr-1"
                      ></v-checkbox>
                    </v-row>
                    <v-treeview
                      :active.sync="active"
                      :items="filteredComplexes"
                      activatable
                      color="indigo"
                      @update:active="getRoles"
                      open-on-click
                      transition
                      dense
                      class="bg-white rounded elevation-1"
                      style="border: 1px solid #e0e0e0;"
                    >
                      <template v-slot:prepend="{ item }">
                        <v-icon
                          small
                          :color="item.children ? 'grey' : 'indigo'"
                        >
                          {{
                            item.children ? "mdi-domain" : "mdi-office-building"
                          }}
                        </v-icon>
                      </template>
                    </v-treeview>
                  </div>
                </v-col>

                <v-divider vertical></v-divider>

                <v-col
                  cols="7"
                  class="pa-4 pl-4"
                  style="height: 100%; overflow-y: auto;"
                >
                  <div
                    class="text-subtitle-1 IranSans font-weight-medium mb-2 grey--text text--darken-2"
                  >
                    {{ `نقش‌های مجموعه ${selectedSubComplex}` }}
                  </div>

                  <v-scroll-y-transition mode="out-in">
                    <div
                      v-if="!complexRoles || complexRoles.length === 0"
                      class="text-center grey--text mt-8"
                    >
                      <v-icon large color="grey lighten-2" class="mb-2"
                        >mdi-information-outline</v-icon
                      >
                      <div>یک مجموعه انتخاب کنید</div>
                    </div>

                    <v-card v-else flat class="bg-transparent">
                      <div v-if="complexRoles.length" class="px-1 mb-1">
                        <v-checkbox
                          :input-value="isAllRolesSelected"
                          :indeterminate="isSomeRolesSelected"
                          label="انتخاب همه"
                          color="indigo"
                          hide-details
                          class="mt-0 font-weight-medium"
                          @change="toggleAllRoles"
                        ></v-checkbox>
                        <v-divider class="mb-1"></v-divider>
                      </div>
                      <v-list dense class="pa-0">
                        <v-list-item
                          v-for="role in complexRoles"
                          :key="role.id"
                          class="px-1"
                        >
                          <v-checkbox
                            :label="role.title"
                            v-model="selectedRoles"
                            :value="role.id"
                            color="indigo"
                            hide-details
                            class="mt-1"
                          ></v-checkbox>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-scroll-y-transition>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>

          <!-- تب دوم: فیلتر فعال/غیرفعال -->
          <v-tab-item>
            <div style="height: 370px; overflow: auto;">
              <v-row class="py-2 ma-0" style="height: 100%;">
                <v-col
                  cols="5"
                  class="pa-4"
                  style="height: 100%; overflow-y: auto;"
                >
                  <div
                    class="text-subtitle-1 IranSans font-weight-medium mb-2 grey--text text--darken-2"
                  >
                    نقش‌ها
                  </div>
                  <div style="height: calc(100% - 40px); overflow-y: auto;">
                    <v-list
                      transition
                      dense
                      class="bg-white rounded elevation-1 pa-1"
                      style="border: 1px solid #e0e0e0;"
                    >
                      <v-list-item
                        v-for="role in allRoles"
                        :key="role.id"
                        @click="selectRole(role)"
                        :class="{
                          'indigo lighten-5':
                            selectedRole && selectedRole.id === role.id
                        }"
                        class="rounded mb-1"
                      >
                        <v-list-item-title>{{ role.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>

                <v-divider vertical></v-divider>

                <v-col
                  cols="7"
                  class="pa-4"
                  style="height: 100%; overflow-y: auto;"
                >
                  <div
                    class="text-subtitle-1 IranSans font-weight-medium mb-2 grey--text text--darken-2"
                  >
                    {{
                      selectedRole
                        ? `انتخاب مجموعه‌ها با نقش ${selectedRole.title}`
                        : "یک نقش انتخاب کنید"
                    }}
                  </div>

                  <v-scroll-y-transition mode="out-in">
                    <div
                      v-if="!selectedRole"
                      class="text-center grey--text mt-8"
                    >
                      <v-icon large color="grey lighten-2" class="mb-2"
                        >mdi-information-outline</v-icon
                      >
                      <div>یک نقش انتخاب کنید</div>
                    </div>

                    <v-card v-else flat class="bg-transparent">
                      <!-- فیلتر فعال/غیرفعال -->
                      <v-row v-if="selectedRole" no-gutters class="mb-3">
                        <v-checkbox
                          v-model="showOnlyActive"
                          label="انتخاب مجموعه‌های فعال"
                          color="indigo"
                          hide-details
                          class="mt-0 ml-4 mr-1"
                          @change="onActiveFilterChanged"
                        ></v-checkbox>
                      </v-row>
                      <div v-if="filteredComplexList.length" class="px-1 mb-1">
                        <v-checkbox
                          :input-value="isAllComplexesSelected"
                          :indeterminate="isSomeComplexesSelected"
                          label="انتخاب همه"
                          color="indigo"
                          hide-details
                          class="mt-0 font-weight-medium"
                          @change="toggleAllComplexes"
                        ></v-checkbox>
                        <v-divider class="mb-1"></v-divider>
                      </div>
                      <v-list dense class="pa-0">
                        <v-list-item
                          v-for="complex in filteredComplexList"
                          :key="`${selectedRole?.id}-${complex.id}`"
                          class="px-1"
                        >
                          <v-checkbox
                            :label="complex.name"
                            v-model="selectedComplexes"
                            :value="`${selectedRole?.id}-${complex.id}`"
                            color="indigo"
                            hide-details
                            class="mt-1"
                            @change="onSelectChanged"
                          />
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-scroll-y-transition>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>

        <v-divider></v-divider>

        <v-card-actions class="justify-end">
          <v-btn text @click="dialog = false">انصراف</v-btn>
          <v-btn color="indigo" dark @click="saveComplexRoles">تایید</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import request from "@/utils/request";

export default Vue.extend({
  name: "AssignRoles",
  props: ["userRole"],
  data: () => ({
    dialog: false,
    mode: 0,
    complexes: [],
    complexRoles: [],
    allRoles: [],
    flatComplexList: [],
    active: [],
    selectedSubComplex: "",
    selectedRoles: [],
    selectedRole: null,
    selectedComplexes: [],
    // فیلترهای تب نقش
    showOnlyActive: false,
    // فیلترهای تب مجموعه
    complexShowOnlyActive: false
  }),
  mounted() {
    if (this.userRole) {
      this.selectedRoles = this.userRole;
      this.selectedComplexes = this.userRole;
    }
    this.getComplexes();
    this.getAllRoles();
  },
  computed: {
    isAllRolesSelected() {
      return (
        this.complexRoles.length > 0 &&
        this.complexRoles.every(r => this.selectedRoles.includes(r.id))
      );
    },
    isSomeRolesSelected() {
      return (
        this.complexRoles.some(r => this.selectedRoles.includes(r.id)) &&
        !this.isAllRolesSelected
      );
    },
    filteredComplexList() {
      return this.flatComplexList;
    },
    filteredComplexes() {
      if (this.complexShowOnlyActive) {
        return this.filterTreeByActive(this.complexes, true);
      }
      return this.complexes;
    },
    selectedRoleComplexIds() {
      if (!this.selectedRole) return [];
      return this.filteredComplexList.map(
        c => `${this.selectedRole.id}-${c.id}`
      );
    },
    isAllComplexesSelected() {
      return (
        this.selectedRoleComplexIds.length > 0 &&
        this.selectedRoleComplexIds.every(id =>
          this.selectedComplexes.includes(id)
        )
      );
    },
    isSomeComplexesSelected() {
      return (
        this.selectedRoleComplexIds.some(id =>
          this.selectedComplexes.includes(id)
        ) && !this.isAllComplexesSelected
      );
    }
  },
  methods: {
    isAllActiveComplexesSelected() {
      if (!this.selectedRole) return false;
      const activeIds = this.flatComplexList
        .filter(c => c.isActive === true)
        .map(c => `${this.selectedRole.id}-${c.id}`);
      return (
        activeIds.length > 0 &&
        activeIds.every(id => this.selectedComplexes.includes(id))
      );
    },
    filterTreeByActive(items, isActive) {
      return items.reduce((acc, item) => {
        if (item.children) {
          const filteredChildren = this.filterTreeByActive(
            item.children,
            isActive
          );
          // فقط اگر فرزند فیلترشده‌ای وجود داشته باشد، والد را نگه می‌داریم
          if (filteredChildren.length > 0) {
            acc.push({
              ...item,
              children: filteredChildren
            });
          }
        }
        // اگر آیتم برگ باشد و isActive آن با فیلتر مطابقت داشته باشد
        else if (item.isActive === isActive) {
          acc.push({ ...item });
        }
        return acc;
      }, []);
    },
    toggleAllRoles(value) {
      const ids = this.complexRoles.map(r => r.id);
      this.selectedRoles = value
        ? Array.from(new Set([...this.selectedRoles, ...ids]))
        : this.selectedRoles.filter(id => !ids.includes(id));
    },
    toggleAllComplexes(value) {
      const ids = this.selectedRoleComplexIds;
      this.showOnlyActive = this.isAllActiveComplexesSelected();
      this.selectedComplexes = value
        ? Array.from(new Set([...this.selectedComplexes, ...ids]))
        : this.selectedComplexes.filter(id => !ids.includes(id));
    },
    initializeUserRole() {
      if (this.userRole) {
        this.selectedRoles = this.userRole;
        this.selectedComplexes = this.userRole;
      }
    },
    getComplexes() {
      request.get("/complex/complex-and-roles").then(res => {
        this.complexes = res.data.result;
        this.flatComplexList = this.flattenComplexes(this.complexes);
      });
    },
    getRoles() {
      if (!this.active.length) return;
      const id = this.active[0];
      const selected = this.findItemById(this.complexes, id);
      this.selectedSubComplex = selected ? selected.name : "";
      request.get(`/complexRole/complex-selected-roles/${id}`).then(res => {
        this.complexRoles = res.data.result;
      });
    },
    findItemById(items, id) {
      for (const item of items) {
        if (item.id === id) return item;
        if (item.children) {
          const found = this.findItemById(item.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    flattenComplexes(items, list = []) {
      items.forEach(item => {
        if (!item.children) {
          list.push({ id: item.id, name: item.name, isActive: item.isActive });
        } else {
          this.flattenComplexes(item.children, list);
        }
      });
      return list;
    },
    getAllRoles() {
      request.get(`/complexRole/roles`).then(res => {
        this.allRoles = res.data.result?.result || [];
      });
    },
    selectRole(role) {
      this.selectedRole = role;
      this.showOnlyActive = this.isAllActiveComplexesSelected();
    },
    onActiveFilterChanged() {
      this.autoSelectFilteredComplexes();
    },
    onSelectChanged() {
      this.showOnlyActive = this.isAllActiveComplexesSelected();
    },
    autoSelectFilteredComplexes() {
      if (!this.selectedRole) return;

      let complexesToSelect = [];

      if (this.showOnlyActive) {
        complexesToSelect = this.flatComplexList.filter(
          c => c.isActive === true
        );
      } else {
        complexesToSelect = [];
      }

      this.selectedComplexes = complexesToSelect.map(
        c => `${this.selectedRole.id}-${c.id}`
      );
    },
    saveComplexRoles() {
      this.dialog = false;
      const finalResult = new Set();
      if (this.mode == 0) {
        if (this.selectedRoles && this.selectedRoles.length > 0) {
          this.selectedRoles.forEach(role => finalResult.add(role));
        }
      } else {
        if (this.selectedComplexes && this.selectedComplexes.length > 0) {
          this.selectedComplexes.forEach(id => {
            finalResult.add(id);
          });
        }
      }
      this.$emit("updateCoplexRoles", Array.from(finalResult));
    }
  }
});
</script>

<style scoped>
.IranSans {
  font-family: "IranSans", sans-serif !important;
}
</style>
